let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1URWz")).then(() => parcelRequire('6Ju1x'));